import { NgModule } from '@angular/core';
import { NbFormModule } from '@showye/nbweb-input/nb-form';

import { TaskRoutingModule } from './task-routing.module';
import { LaunchComponent } from './launch.component';
import { NbSignerModule } from '@showye/nbweb-input/nb-signer';
import { ShowyePageBaseModule } from '@showye/showye-page-base';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzCardModule } from 'ng-zorro-antd/card';
import { PageHeaderModule } from '@delon/abc/page-header';
import { SVModule } from '@delon/abc/sv';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { EditComponent } from './edit.component';
import { ViewComponent } from './view.component';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { ViewTaskComponent } from './view-task.component';
import { EditTaskComponent } from './edit-task.component';
import { SharedModule } from '@shared';
import { NodeViewComponent } from './node-view.component';

const COMPONENTS = [LaunchComponent, EditComponent, ViewComponent, ViewTaskComponent, EditTaskComponent, NodeViewComponent];

@NgModule({
  imports: [
    SharedModule,
    ShowyePageBaseModule,
    TaskRoutingModule,

    NzCardModule,
    NzButtonModule,
    NzGridModule,
    NzFormModule,
    NzIconModule,
    NzInputModule,
    NzModalModule,
    NzMessageModule,
    NzNotificationModule,
    NzTabsModule,
    NzPageHeaderModule,
    PageHeaderModule,
    NbFormModule,
    NbSignerModule,
    SVModule,
    NzDividerModule,
    NzDescriptionsModule,
    NzTagModule,
    NzSelectModule,
    NzTimelineModule,
  ],
  declarations: [...COMPONENTS],
  exports: [NodeViewComponent],
})
export class TaskModule {}
